import React from 'react';

import { Status } from '@gogame/components';

export const getColor = (id) => {
  switch (id) {
    case 0:
    case 1:
      return 'inactive';
    case 2:
    case 3:
    case 4:
      return 'error';
    case 6:
      return 'info';
    case 5:
      return 'draft';
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 12:
    case 13:
    case 14:
    case 15:
    case 17:
      return 'pending';
    case 16:
      return 'success';
  }
};

const IOStatus = ({ id, children }) => {
  return <Status color={getColor(id)}> {children} </Status>;
};

export default IOStatus;
